import React, { useEffect, useState } from "react";
import { Row, Col, Steps, Popover, Input, DatePicker, Select } from "antd";
import moment from "moment";
import media from "../../../media";
import CardHeader from "../../../components/atoms/cardHeader";
import {
  ReturnAcceptThunk,
  ReturnChangeStatusThunk,
} from "../../../store/thunks/returnThunk";
import { useDispatch } from "react-redux";

export const Shipment = ({ propData,data, orderRefId, statusBar }) => {
  const dispatch= useDispatch()
  const { Step } = Steps;
  // Declaring Popovers
  const customDot = (dot) => <Popover>{dot}</Popover>;
  const [externalData, setExternalData] = useState({
    orderStage: "ORDER_RETURN_BACK_IN_TRANSIT",
    orderRefID: orderRefId,
  });
  const { Option } = Select;
  const selectAfter = (
    <Select defaultValue="" className="select-after">
      <Option value="Kg">Kg</Option>
      <Option value="Gm">Gm</Option>
    </Select>
  );

  const selectAfterCm = (
    <Select defaultValue="Cm" className="select-after">
      <Option value="Cm">Cm</Option>
    </Select>
  );
  //   Return State
  const [returnState, setReturnState] = useState({
    orderRefId: orderRefId,
  });
  useEffect(() => {
    setReturnState({
      ...returnState,
      deliveryMode: data?.deliveryMode,
      height: data?.height,
      width: data?.width,
      breadth: data?.breadth,
      weight: data?.weight,
      externalDeliveryMode: data?.externalDeliveryMode,
    });
  }, [data]);
  return (
    <>
      <div className="steps">
        <Row gutter={[30, 30]} className="mt-5 mb-10">
          <Col className="gutter-row" xs={24}>
            <Steps
              current={statusBar?.length}
              progressDot={customDot}
              className="custom-steps"
            >
              {statusBar &&
                statusBar.map((orderStatus, index) => {
                  return (
                    <>
                      <Step
                        title={
                          <>
                            <span className="d-block">
                              {orderStatus?.orderStage}
                            </span>
                            <span
                              className="font-size-sm d-block"
                              style={{ fontSize: "11px" }}
                            >
                              {moment
                                .utc(orderStatus?.date)
                                .local()
                                .format("DD-MM-YYYY hh:mm A")}
                            </span>
                          </>
                        }
                      />
                    </>
                  );
                })}
            </Steps>
          </Col>
        </Row>
      </div>

      {/*By Pickrr Start*/}
      <div className="bypickrr">
        {/*Product Packaging Start*/}
        {
          <div className="card card-custom mb-5">
            <CardHeader name={"Product Packaging"} />
            <div className="border-1 border-dark border-top-0 card-body p-0">
              <div className="table-responsive">
                <table className="table table-bordered text-center m-0 border radius-remove">
                  <thead>
                    <tr>
                      <th className="align-middle text-left">ITEMS</th>
                      <th className="align-middle">DELIVERY OPTION</th>
                      <th className="align-middle" colSpan={3}>
                        ITEM DIMENSIONS
                      </th>
                      <th className="align-middle">ITEM WEIGHT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex">
                          <div className="symbol symbol-50 flex-shrink-0 mr-4">
                            <img
                              src={
                                data?.imageUrl ? data?.imageUrl : media.Default
                              }
                              className="w-100"
                              alt=""
                            />
                          </div>
                          <div className="d-flex flex-column font-weight-bold text-left">
                            <span className="">
                              {data?.productName?.en} -{" "}
                              {/* {propData?.returnProductRequest?.variant} */}
                            </span>
                            <span className="text-muted">
                              SKU: {data?.sku || "--"}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {/* {propData?.returnProductRequest?.deliveryOption ===
                        "PICK_UP_FROM_VENDOR"
                          ? "PICK UP"
                          : "HOME DELIVERY"} */}
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-column">
                          <span className="font-weight-bold">Length</span>
                          <span className="text-muted">{data?.breadth} cm</span>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-column">
                          <span className="font-weight-bold">Width</span>
                          <span className="text-muted">{data?.width} cm</span>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-column">
                          <span className="font-weight-bold">Height</span>
                          <span className="text-muted">{data?.height} cm</span>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-column">
                          <span className="text-muted">{data?.weight} Kg</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-4">
                <Row gutter={[12, 12]} justify="center" id="" className="mt-8">
                  <Col className="gutter-row" xs={24} lg={6}>
                    <label className="font-weight-bolder font-size-sm d-block">
                      Total Package Weight
                    </label>
                    <span className="text-dark">
                      {data?.weight} <span className="mx-2">Kg</span>
                    </span>
                  </Col>
                  <Col className="gutter-row" xs={24} lg={8}>
                    <label className="font-weight-bolder font-size-sm d-block">
                      Package Dimensions
                    </label>
                    <span className="text-dark">
                      {data?.breadth} <span className="mx-2">X</span>{" "}
                      {data?.width} <span className="mx-2">X</span>{" "}
                      {data?.height} <span className="mx-2">cm</span>{" "}
                    </span>
                  </Col>
                </Row>
                {data && data.orderStatus === "RETURN" && (
                  <div className="my-5 text-center">
                    <button
                      type="submit"
                      className="all_bottom_buttons"
                      onClick={() => {
                        dispatch(
                          ReturnChangeStatusThunk({
                            orderStatusChangeRequest: {
                              orderRefID: orderRefId,
                              orderStage: "RETURN_CANCELLED",
                            },
                          })
                        );
                      }}
                    >
                      Decline Return
                    </button>
                    <button
                      type="submit"
                      className="all_bottom_buttons"
                      onClick={() => {
                        dispatch(
                          ReturnAcceptThunk({
                            approveOrderRequest: returnState,
                          })
                        );
                      }}
                    >
                      Accept Return
                    </button>
                  </div>
                )}
                {/**Dimensions Change Modal Start**/}
                <div
                  className="modal fade"
                  id="dimensionsmodal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header bg-gray-700 p-4">
                        <h5
                          className="modal-title text-white"
                          id="domainlLabel"
                        >
                          Change Dimensions
                        </h5>
                        <button
                          type="button"
                          className="close opacity-100"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <i
                            aria-hidden="true"
                            className="ki ki-close text-white"
                          ></i>
                        </button>
                      </div>
                      <div className="modal-body p-3" id="ant_inputs">
                        <form action="" method="get" acceptCharset="utf-8">
                          <Row gutter={[12, 12]}>
                            <Col className="gutter-row" xs={24}>
                              <label className="font-weight-bolder font-size-sm">
                                Total Package Weight
                              </label>
                              <Input addonAfter={selectAfter} defaultValue="" />
                            </Col>

                            <Col className="gutter-row" xs={24}>
                              <label className="font-weight-bolder font-size-sm">
                                Package Dimensions
                              </label>
                              <Row>
                                <Col lg={8}>
                                  <Input
                                    addonAfter={selectAfterCm}
                                    defaultValue=""
                                  />
                                </Col>
                                <Col lg={8}>
                                  <Input
                                    addonAfter={selectAfterCm}
                                    defaultValue=""
                                  />
                                </Col>
                                <Col lg={8}>
                                  <Input
                                    addonAfter={selectAfterCm}
                                    defaultValue=""
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <button
                            type="submit"
                            className="mx-auto mt-10 d-block btn btn-primary font-weight-bold btn-md"
                          >
                            Update
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/**Dimensions Change Modal End**/}
              </div>
            </div>
          </div>
        }
        {/*Product Packaging End*/}

        {/*Change Delivery Status Start*/}
        {(data?.orderStatus === "ORDER_RETURN_BACK_IN_TRANSIT" ||
          data?.orderStatus === "ORDER_RETURN_BACK" ||
          data?.orderStatus === "ORDER_RETURN_BACK_UNDELIVERED" ||
          data?.orderStatus === "ORDER_RETUREND_TO_SELLER") &&
          data.deliveryMode === "SELF" && (
            <>
              <div className="card-title align-items-start flex-column justify-content-center">
                <h3 className="card-label font-weight-bolder">
                  Change Return Status
                </h3>
              </div>
              <div className="my-5 text-center">
                <Select
                  style={{ width: "500px" }}
                  placeholder="Select Return Status"
                  options={[
                    {
                      label: "Return item(s) collected from the customer",
                      value: "ORDER_RETURN_BACK",
                    },
                    {
                      label: "Return item(s) back to seller",
                      value: "ORDER_RETUREND_TO_SELLER",
                    },
                    { label: "Return Completed", value: "RETURN_COMPLETED" },
                    {
                      label: "Return pickup failed - Customer Unavailable",
                      value: "ORDER_RETURN_BACK_UNDELIVERED",
                    },
                    {
                      label: "Cancel return request",
                      value: "RETURN_CANCELLED",
                    },
                  ]}
                  onChange={(val) => {
                    dispatch(
                      ReturnChangeStatusThunk({
                        orderStatusChangeRequest: {
                          orderStage: val,
                          orderRefID: orderRefId,
                        },
                      })
                    );
                  }}
                ></Select>
              </div>
            </>
          )}

        {/*Change Delivery Status End*/}

        {/*Shipping Information Start*/}
        <div className="card card-custom mb-5">
          <CardHeader name="Shipping Information" />
          <div className="border-1 border-dark border-top-0 card-body p-0">
            <Row gutter={[12, 12]} id="">
              <Col className="gutter-row" xs={24}>
                <div className="table-responsive">
                  <table className="table table-bordered text-center m-0 border radius-remove">
                    <thead>
                      <tr>
                        <th className="align-middle">Product Image</th>
                        <th className="align-middle">Product Name</th>
                        <th className="align-middle">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="align-middle">
                          <div className="symbol symbol-50 flex-shrink-0 mr-4">
                            <img
                              src={data?.imageUrl}
                              className="w-100"
                              alt=""
                            />
                          </div>
                        </td>
                        <td className="align-middle">
                          {data?.productName?.en} -{" "}
                          {propData?.returnProductRequest?.variant}
                        </td>
                        <td className="align-middle">
                          {propData?.returnProductRequest?.quantity}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {/*Shipping Information End*/}

        {/*Tracking Information Start*/}
        {data && data.orderStatus === "ORDER_RETURN_BACK_IN_TRANSIT" && (
          <div className="card card-custom mb-5">
            <CardHeader name="Tracking Information" />
            <div className="border-1 border border-light-dark border-top-0 card-body p-0">
              <Row gutter={[12, 12]} id="">
                <Col className="gutter-row" xs={24}>
                  <div className="table-responsive">
                    <table className="table table-bordered m-0 border radius-remove">
                      <thead className="">
                        <tr>
                          <th className="align-middle">Shipment Type</th>
                          <th className="align-middle">Shipping Provider</th>
                          <th className="align-middle">Date Shipped</th>
                          <th className="align-middle">Tracking Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-middle">
                            {data?.shipmentType || "--"}
                          </td>
                          <td className="align-middle">
                            {data?.shipmentMode || "--"}
                          </td>
                          <td className="align-middle">
                            {moment(data?.dateShipped).format(
                              "DD/MM/YYYY hh:mm A"
                            )}
                          </td>
                          <td className="align-middle">
                            {" "}
                            {data?.trackingId || "--"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
        {/*Tracking Information End*/}

        {/*Tracking Information Start*/}
        {data?.orderStatus === "RETURN_ACCEPTED" &&
          data.deliveryMode === "SELF" && (
            <div className="card card-custom mb-5">
              <CardHeader name="Tracking Information" />
              <div className="border-1 border border-light-dark border-top-0 card-body p-3">
                <Row gutter={[12, 12]}>
                  <Col className="gutter-row" xs={24} lg={6}>
                    <div className="">
                      <label className="font-weight-bolder font-size-sm d-block">
                        Shipment Type
                      </label>
                      <span className="ant-input">{data?.shipmentType}</span>
                    </div>
                  </Col>
                  <Col className="gutter-row" xs={24} lg={6}>
                    <div className="">
                      <label className="font-weight-bolder font-size-sm d-block">
                        Shipping Provider
                      </label>
                      <Input
                        placeholder="Shipping Provider"
                        type="text"
                        onChange={(e) => {
                          setExternalData({
                            ...externalData,
                            shipmentProvider: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </Col>
                  <Col className="gutter-row" xs={24} lg={6}>
                    <div className="">
                      <label className="font-weight-bolder font-size-sm d-block">
                        Date Shipped
                      </label>
                      <DatePicker
                        placeholder="Date Shipped"
                        type="text"
                        className="w-100"
                        disabledDate={(current) => {
                          return moment().add(0, "days") <= current;
                        }}
                        onChange={(date, dateString) => {
                          setExternalData({
                            ...externalData,
                            shipmentDate:
                              date &&
                              date["_d"] &&
                              moment(date["_d"]).format("YYYY-MM-DDThh:mm:ss"),
                          });
                        }}
                      />
                    </div>
                  </Col>

                  <Col className="gutter-row" xs={24} lg={6}>
                    <div className="">
                      <label className="font-weight-bolder font-size-sm d-block">
                        Tracking Number
                      </label>
                      <Input
                        placeholder="Tracking Number"
                        type="text"
                        onChange={(e) => {
                          setExternalData({
                            ...externalData,
                            trackingId: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="my-5 text-center">
                  <button
                    type="submit"
                    className="all_bottom_buttons"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(
                        ReturnChangeStatusThunk({
                          orderStatusChangeRequest: {
                            orderStage: "CANCELLED",
                            orderRefID: orderRefId,
                          },
                        })
                      );
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="all_bottom_buttons"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(
                        ReturnChangeStatusThunk({
                          orderStatusChangeRequest: externalData,
                        })
                      );
                    }}
                  >
                    Create Reverse Shipment
                  </button>
                </div>
              </div>
            </div>
          )}
        {/*Tracking Information End*/}
      </div>
      {/*By Pickrr End*/}
    </>
  );
};
